module.exports = __webpack_public_path__ + "assets/93e8bb4eb61b827e42d49cad21d90728.png";